<div class="kpi">
  <div class="kpi-label">{{ data.title }}</div>
  @if (data.sub) {
    <div class="kpi-sub">{{ data.sub }}</div>
  }

  <div class="kpi-bar">
    <div class="kpi-bar-seg" [style.width.%]="data.items[0].pct" [style.background]="data.items[0].color"></div>
    <div class="kpi-bar-seg" [style.width.%]="data.items[1].pct" [style.background]="data.items[1].color"></div>
  </div>

  <div class="kpi-cols">
    @for (item of data.items; track $index) {
      <div class="kpi-col">
        <div class="kpi-col-header">
          <span class="kpi-bullet" [style.background]="item.color"></span>
          <span class="kpi-col-label">{{ item.label }}</span>
        </div>
        <div class="kpi-value">{{ item.value }}</div>
        <div class="kpi-col-pct" [style.color]="item.color">{{ item.pct }}%</div>
      </div>
    }
  </div>
</div>
